<div class="d-flex flex-column h-100">
  <div class="d-flex flex-column bgcomp h-100 px-3 py-3">
    <div mat-dialog-title class="d-flex">
      <h2
        class="drag-handle-header text-center flex-grow-1 mt-1"
        cdkDrag
        cdkDragRootElement=".draggable-dialog-container.new-clinical-feedback-dialog"
        cdkDragBoundary=".cdk-overlay-container"
        cdkDragHandle
      >
        Raise Clinical Feedback
      </h2>
      <button
        mat-button
        class="close-icon"
        tabIndex="0"
        id="closeCFBtn"
        *ngIf="isFromDialog"
        (click)="showConfirmationPopupIfDirty()"
        [disabled]="saving"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content
      class="custom-scrollbar overflow-auto m-0 p-0"
      #dialogContentScrollArea
    >
      <form
        class="d-flex flex-column"
        [formGroup]="clinicalFeedbackForm"
        autocomplete="off"
      >
        <div class="container-fluid">
          <app-patient-details-form [order]="order"></app-patient-details-form>
          <app-feedback-form [region]="order.region"></app-feedback-form>
          <app-advised-serious-incident-form
            [accessionNumber]="order.accessionNumber"
            [region]="order.region"
          ></app-advised-serious-incident-form>
          <app-addendum-form></app-addendum-form>
          <app-attachments-form
            [accessionNumber]="order.accessionNumber"
          ></app-attachments-form>
          <app-contact-detail-form
            [region]="order.region"
          ></app-contact-detail-form>
          <div class="row section-row mt-3">
            <div class="col-12 section-col">
              <div class="my-4 text-right">
                <button
                  id="saveAndClose"
                  (click)="onSubmit()"
                  class="everbtnsave"
                  type="button"
                  tabIndex="0"
                  [disabled]="saving || !clinicalFeedbackForm.dirty"
                >
                  <fa-icon
                    [icon]="faCircleNotch"
                    [spin]="true"
                    *ngIf="saving"
                  ></fa-icon>
                  <span *ngIf="!saving">Save</span>
                </button>
                <button
                  (click)="showConfirmationPopupIfDirty()"
                  id="cancelCFBtn"
                  class="everbtncancel"
                  type="button"
                  tabIndex="0"
                  [disabled]="saving"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </mat-dialog-content>
  </div>
</div>
